<template>
  <input type="text" inputmode="numeric" :data-placeholder="isPlaceHolder"
        v-model="displayValue"
        v-restrict.number
        @blur="setActive(false)"
        @focus="setActive(true)"/>
</template>

<script>
import format from '@/common/utilities/format';
export default {
    name: 'mvtInputCurrency',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: Number,
            default: 0,
            required: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        disableFriendlyPrice:{
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            actived: false,
            val: this.modelValue || 0
        }
    },
    watch: {
        modelValue() {
            this.val = this.modelValue;
        }
    },
    methods: {
        setActive(actived) {
            this.actived = actived;
            if (this.actived) {
                this.$emit('actived');
            } else if (this.val !== this.modelValue) {
                this.$emit('update:modelValue', this.val);
            }
        },
    },
    computed: {
        isPlaceHolder: function() {
            return this.displayValue === this.placeholder;
        },
        displayValue: {
            get: function() {
                if (this.actived) {
                    return format.formatNumberByComma(this.val);
                } else if (!(this.val > 0) && this.placeholder) {
                    return this.placeholder;
                } else if(this.disableFriendlyPrice){
                    return `$${format.formatNumberByComma(this.val)}` || this.placeholder;
                } else {
                    return `$${format.friendlyPrice(this.val)}` || this.placeholder;
                }
            },
            set: function(modifiedValue) {
                let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ''))
                if (isNaN(newValue)) {
                    newValue = 0
                }
                this.val = newValue;
                // this.$emit('update:modelValue', this.val);
            }
        }
    }
}
</script>
